import { CommandAuditSection } from "modules/system/sections/plt/field-management/command-audit/CommandAuditSection";
import React from "react";

import { Stack, useTheme } from "@bps/fluent-ui";
import { SectionTitle } from "@components/SectionTitle";
import { FieldDevice } from "@libs/api/gateways/field/field-ops-gateway.dtos";

interface FieldDeviceOverviewProps {
  device: FieldDevice;
}

export const DeviceCommandAudit: React.FC<FieldDeviceOverviewProps> = ({
  device
}) => {
  const theme = useTheme();
  return (
    <Stack
      verticalFill
      styles={{
        root: {
          padding: theme.spacing.s1,
          width: "100%",
          overflow: "hidden"
        }
      }}
      tokens={{ childrenGap: theme.spacing.m }}
    >
      <SectionTitle>Device Command Audit</SectionTitle>

      <CommandAuditSection device={device} />
    </Stack>
  );
};
